import { useTranslation } from 'react-i18next'

import { Text } from '@reveni-io/reveni-ui'

import ShippingLabelFormat from './ShippingLabelFormat'
import * as Styles from './styles'

const ShippingLabelFormatSection = ({ value, onChange }) => {
  const { t } = useTranslation()

  return (
    <Styles.Container>
      <Text type="titleM">{t('Generación de etiquetas')}</Text>
      <Text type="bodyMRegular">
        {t(
          'Define en qué formato deben generarse las etiquetas de envío según tu flujo de impresión y preparación de pedidos.'
        )}
      </Text>
      <ShippingLabelFormat value={value} onChange={onChange} />
    </Styles.Container>
  )
}

export default ShippingLabelFormatSection
